// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoColumn_container_38K01","mainColumn":"TwoColumn_mainColumn_m_Cvf","sideColumn":"TwoColumn_sideColumn_xbbtf"};